module.exports = __webpack_public_path__ + "assets/plus.e752eafd.svg";